import { render } from "./CharStatsTable.vue?vue&type=template&id=4db055fe&scoped=true&ts=true"
import script from "./CharStatsTable.vue?vue&type=script&lang=ts"
export * from "./CharStatsTable.vue?vue&type=script&lang=ts"

import "./CharStatsTable.vue?vue&type=style&index=0&id=4db055fe&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db055fe"]])

export default __exports__